// src/services/api/shipping.js
import { apiClient } from './base';

export const getShippingZones = async () => {
  try {
    const response = await apiClient.get('/shipping-zones');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createShippingZone = async (zoneData) => {
  try {
    const response = await apiClient.post('/shipping-zones', zoneData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateShippingZone = async (zoneId, zoneData) => {
  try {
    const response = await apiClient.put(`/shipping-zones/${zoneId}`, zoneData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteShippingZone = async (zoneId) => {
  try {
    const response = await apiClient.delete(`/shipping-zones/${zoneId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};